/**
 * Stili dei pulsanti con contrasto di almeno 7:1 sul bianco (WCAG 2.2 AAA, 1.4.6): `primary.main` e
 * `error.main` del tema EasyCare arrivano a 6,3:1 e 3,9:1, quindi testo e fondi usano `primary.dark`
 * (10:1) ed `error.darker`. Contorno di focus da tastiera di 3px ben distinto (2.4.13) e bersagli di
 * almeno 44×44 px (2.5.5). Nati con la schermata di consenso dell'MCP (#151, PAGE-011).
 */

/** Bersaglio di almeno 44×44 px (2.5.5). */
export const TARGET_SX = { minHeight: 44, minWidth: 44 } as const;

/** Contorno di focus da tastiera (2.4.13): il solo ripple di MUI non basta. */
export const FOCUS_SX = {
  '&.Mui-focusVisible': { outline: '3px solid', outlineColor: 'primary.darker', outlineOffset: '3px' },
} as const;

/** `variant="contained"`: bianco su `primary.dark`. */
export const PRIMARY_BUTTON_SX = {
  ...TARGET_SX,
  ...FOCUS_SX,
  bgcolor: 'primary.dark',
  '&:hover': { bgcolor: 'primary.darker' },
} as const;

/** `variant="contained"` per le azioni distruttive: bianco su `error.darker`. */
export const DANGER_BUTTON_SX = {
  ...TARGET_SX,
  ...FOCUS_SX,
  bgcolor: 'error.darker',
  '&:hover': { bgcolor: 'error.darker', boxShadow: 3 },
} as const;

/** `variant="outlined"` o `variant="text"`: testo (e contorno) `primary.dark`. */
export const SECONDARY_BUTTON_SX = {
  ...TARGET_SX,
  ...FOCUS_SX,
  color: 'primary.dark',
  borderColor: 'primary.dark',
} as const;
